import { createFileRoute } from "@tanstack/react-router";
import { CoachChat } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/coach")({
  head: () => seoHead({ title: "Coach chat", noindex: true }),
  component: CoachChat,
});
